import { UserCardWrapper } from "./styles";
import {
  SkeletonCard,
  SkeletonText,
  SkeletonButton,
  SkeletonContainer,
} from "./styles/skeleton";

const UserCardSkeleton = () => {
  return (
    <UserCardWrapper>
      <SkeletonCard>
        <SkeletonContainer>
          {/* 우측 상단 버튼 */}
          <SkeletonButton />

          {/* 헤더 영역 */}
          <div className="header">
            <SkeletonText width="80px" height="16px" />
            <div className="item">
              <SkeletonText width="120px" height="28px" />
            </div>
          </div>

          {/* 하단 정보 영역 */}
          <div className="footer">
            <SkeletonText width="100%" height="60px" />
          </div>
        </SkeletonContainer>
      </SkeletonCard>
    </UserCardWrapper>
  );
};

export default UserCardSkeleton;
